module.exports = __webpack_public_path__ + "img/yt.40bc9812.svg";